import { MutationCache, QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/lib/apiClient";

export const queryClient: QueryClient = new QueryClient({
  mutationCache: new MutationCache({ onSuccess: () => { void queryClient.invalidateQueries({ queryKey: ["resource-search"] }); } }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Retrying a 4xx just delays the error the user needs to see. Every
      // invitation failure (expired, already responded, revoked) is a 4xx, and
      // re-POSTing them would also burn the endpoint's 5/minute IP budget.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      // Never automatic for mutations: a retried accept is a second write
      // attempt against a token that may already have been consumed.
      retry: false,
      // Fail offline writes immediately; never queue or replay them later.
      networkMode: "always",
    },
  },
});
